const interceptGetSchedule = (store) => (next) => (action) => {
  if (action.type === 'date/getSchedule/fulfilled') {
    const actionDate = action.meta.arg.date;
    const { selectedDate } = store.getState().date;
    if (actionDate === selectedDate) next(action);
  } else next(action);
};

export default interceptGetSchedule;
